import { SurveyDeployerPageResponseJSON } from './../Survey-Deployer-Page-Response-JSON';
import { HTMLDisplayComponentJSON } from './../htmlComponent/HTML-Display-Component-JSON';
import { HTMLDisplayComponentRequestJSON } from "./HTML-Display-Component-Request.JSON";
import { SurveyDeployerConfigResponseJSON } from "./../surveyConfig/Survey-Deployer-Config-Response-JSON";

export class WCPageServiceRequestJSON {
    surveyID: Number;
    welcomePageText: String;
    hHTMLDisplayComponentJSONList: HTMLDisplayComponentRequestJSON[];
    itemsPerRow: number;
    listSize: number;
    surveyDeployerConfigResponseJSON: SurveyDeployerConfigResponseJSON;

    constructor() {

        this.hHTMLDisplayComponentJSONList = new Array<HTMLDisplayComponentRequestJSON>();
    }
}